import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignTabBase, CampaignTabItem } from '../shared/campaign-tab-base';

export type TabItem = CampaignTabItem;

/**
 * Renders a vertical campaign tab view with efficient list tracking helpers for template rendering.
 * @component
 * @selector app-vertical-tab
 * @example
 *   <app-vertical-tab></app-vertical-tab>
 * @method trackByIndex - Returns the current item index for Angular's ngFor tracking.
 * @method trackByValue - Returns an item's value property, or the item itself, for tracking.
 * @method trackById - Returns an item's id property, or the item itself, for tracking.
 * @method trackByString - Returns the provided string/item reference for tracking.
 * @lifecycle OnInit, OnChanges, OnDestroy - Inherits lifecycle behavior from CampaignTabBase.
 */
@Component({
  selector: 'app-vertical-tab',
  imports: [CommonModule],
  templateUrl: './vertical-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './vertical-tab.component.scss',
})
export class VerticalTabComponent extends CampaignTabBase {
  trackByIndex(index: number): number {
    return index;
  }
  trackByValue(_: number, item: any): any {
    return item?.value ?? item;
  }
  trackById(_: number, item: any): any {
    return item?.id ?? item;
  }
  trackByString(_: number, s: any): any {
    return s;
  }
}
